var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"hs",style:(_vm.styling),attrs:{"src":_vm.iconSource,"contain":""},on:{"click":_vm.clicked}})}
var staticRenderFns = []

export { render, staticRenderFns }